import { createSelector } from '@reduxjs/toolkit';
import { selectMultiActFormSelector } from '../selectors';

export const selectMultiActDialogState = () =>
  createSelector(selectMultiActFormSelector, (state) => state.openMultiActDialog);

export const selectMultiActProgressState = () =>
  createSelector(selectMultiActFormSelector, (state) => state.multiActProgress);
